var _desc, _circle, _polygon, _polygon2, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiChatAssistantIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "AI Chat Assistant") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Circular navy chat bubble avatar with a yellow geometric AI mark and the text AI Chat Assistant.")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 104,
    r: 72,
    fill: "#124066"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "90,167 65,204 117,172",
    fill: "#124066"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "120,49 150,79 138,113 98,113",
    fill: "#FBD359"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 65,
    r: 6,
    fill: "#FBD359"
  })), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 145,
    textAnchor: "middle",
    style: {
      fill: "#FBD359",
      fontWeight: 700,
      fontSize: 11,
      letterSpacing: "0.45px",
      fontFamily: "Arial,Helvetica,sans-serif"
    }
  }, "\n    AI Chat Assistant\n  "));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiChatAssistantIcon);
export default __webpack_public_path__ + "static/media/AI_Chat_Assistant_Icon.7043a2e139d33196fb049b8c98118abf.svg";
export { ForwardRef as ReactComponent };